import { Cookies } from 'react-cookie';
import { getRequest, postRequest } from '../../../utils/apiUtils';
import {
  CLIENT_ID, CLIENT_SECRET, GRANT_TYPE,
} from '../../../utils/constants';
import { aesDecrypt } from '../../../utils/cryptoHelper';

export const postLogin = (data: Auth.LoginForm) => {
  const { password, username } = data;
  const loginRequestBody = {
    client_secret: CLIENT_SECRET,
    client_id: CLIENT_ID,
    grant_type: GRANT_TYPE,
    username,
    password,
    roleId: 10,
    second_step: 0,
  };

  return postRequest('/oauth2/login', loginRequestBody);
};

export const postOtp = (data: Auth.OtpForm) => {
  const cookies = new Cookies();
  const { code } = data;
  const encryptedUsername = cookies.get('username');
  const encryptedPassword = cookies.get('password');

  const username = aesDecrypt(encryptedUsername);
  const password = aesDecrypt(encryptedPassword);

  const otpRequestBody = {
    client_secret: CLIENT_SECRET,
    client_id: CLIENT_ID,
    grant_type: GRANT_TYPE,
    username,
    password,
    code,
    roleId: 10,
    second_step: 1,
  };

  return postRequest<Auth.OtpResponse>('/oauth2/login', otpRequestBody);
};

export const postResetOtp = (data: Auth.ResendOtpForm) => {
  const resendOtpRequestBody = {
    client_secret: CLIENT_SECRET,
    client_id: CLIENT_ID,
    email: data.email,
  };
  return postRequest<Auth.ResendOtpResp>('/oauth2/resend-otp-code', resendOtpRequestBody);
};

export const getUserData = () => {
  return getRequest<CapBayApiData<Auth.UserData>>('/p2p-admin/user-data');
};
